export default "assets/images/chouette_bg-1ea70481.png";